import { render, staticRenderFns } from "./disease_science.vue?vue&type=template&id=62b736c2&scoped=true&"
import script from "./disease_science.vue?vue&type=script&lang=js&"
export * from "./disease_science.vue?vue&type=script&lang=js&"
import style0 from "./disease_science.vue?vue&type=style&index=0&id=62b736c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b736c2",
  null
  
)

export default component.exports